export class ApiError extends Error {
  constructor(message, options = {}) {
    super(message);
    this.name = "ApiError";
    this.status = Number(options.status || 0);
    this.code = String(options.code || "ROOTS_API_ERROR");
    const retryValue = options.retryAfterSeconds;
    this.retryAfterSeconds = retryValue !== null && retryValue !== undefined && retryValue !== "" && Number.isFinite(Number(retryValue))
      ? Number(retryValue)
      : null;
  }
}

async function request(path, options = {}) {
  const response = await fetch(`/api${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    }
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new ApiError(body.error || "ROOTS could not complete that request.", {
      status: response.status,
      code: body.code || response.headers.get("X-ROOTS-Error-Code") || "ROOTS_API_ERROR",
      retryAfterSeconds: body.retryAfterSeconds ?? response.headers.get("Retry-After")
    });
  }
  return body;
}

export const api = {
  bootstrap: () => request("/bootstrap"),
  readOnlyTransactions: () => request("/transactions-readonly"),
  searchFubPeople: ({ field, query, signal }) => request(
    `/fub-people-search?field=${encodeURIComponent(field)}&q=${encodeURIComponent(query)}`,
    { signal }
  ),
  createTransaction: payload => request("/transactions", {
    method: "POST",
    body: JSON.stringify(payload)
  }),
  approveTransaction: id => request(`/transactions/${id}/approve`, { method: "POST" }),
  updateTask: (id, payload) => request(`/tasks/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload)
  })
};
